import { useEffect, useState } from 'react';

import { ScreenType, ScreenTypeContext } from './ScreenTypeContext';

function getScreenType(width: number): ScreenType {
  if (width <= 767) return 'mobile';
  if (width <= 1023) return 'tablet';
  if (width <= 1439) return 'laptop';
  return 'desktop';
}

export function ScreenTypeProvider({ children }: { children: React.ReactNode }) {
  const [screenType, setScreenType] = useState<ScreenType>(getScreenType(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setScreenType(getScreenType(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return <ScreenTypeContext.Provider value={{ screenType }}>{children}</ScreenTypeContext.Provider>;
}
